module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-ExtraLight-ac925bdb218fad8ee04958a4e1debfdb.woff";